// @ts-nocheck
import { DEFAULT_LAST_N } from 'lib-jitsi-meet/dist/esm/service/RTC/StandardVideoQualitySettings';
export const QUALITY_EVENTS_WILDIX = {
    LAST_N: 'LAST_N',
    VIDEO_RESOLUTION: 'VIDEO_RESOLUTION',
    VIDEO_CODEC: 'VIDEO_CODEC'
};
export const QUALITY_CONTROL_TIMERS_WILDIX = {
    HIDE: 20000
};
export const QUALITY_CONTROL_LABELS = {
    LAST_N: DEFAULT_LAST_N
};
